import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedNotetitle: null, // filtering
  selectedAssets: [], // filtering
  selectedStakeholders: [], // filtering
  selectedNoteDate: null, // filtering
  selectedLabels: [], // filtering
  page: 1,
  rowsPerPage: 10,
  sort: {
    keytoSort: "modified",
    direction: "desc",
  },
};
const activityNoteSlice = createSlice({
  name: "activityNote",
  initialState: initialState,
  reducers: {
    setSelectedNotetitle: (state, action) => {
      state.selectedNotetitle = action.payload;
    },
    setSelectedAssets: (state, action) => {
      state.selectedAssets = action.payload;
    },
    setSelectedStakeholders: (state, action) => {
      state.selectedStakeholders = action.payload;
    },
    setSelectedNoteDate: (state, action) => {
      state.selectedNoteDate = action.payload;
    },
    setSelectedLabels: (state, action) => {
      state.selectedLabels = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
  },
});

export const {
  setSelectedNotetitle,
  setSelectedAssets,
  setSelectedStakeholders,
  setSelectedNoteDate,
  setSelectedLabels,
  setPage,
  setRowsPerPage,
  setSort
} = activityNoteSlice.actions;
export default activityNoteSlice.reducer;
